<template>
  <el-form ref="form" :model="form" class="box-set" label-width="120px">
    <el-card header="基础信息" shadow="naver">
      <el-form-item label="名称" prop="marketing_name" :rules="{required: true, message: '活动名称必填', trigger: 'blur'}">
        <el-col :span="20">
          <el-input v-model="form.marketing_name" :maxlength=30 placeholder="最多30个字"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="促销规则">
        <div>
          <el-radio v-model="form.condition_type" label="quantity">按总件数</el-radio>
          <el-radio v-model="form.condition_type" label="totalfee">按总金额</el-radio>
        </div>
        <div>
          <el-button type="primary" @click="addRules()" size="mini">添加满折区间</el-button>
          <div v-if="form.condition_type == 'totalfee'" v-for="(item,key) in conditionValue" :key="key" class="content-padded">
            消费满 <el-input type="input" v-model="item.full" placeholder="0.00" style="width:100px" size="mini"></el-input> 元，给予 <el-input type="input" v-model="item.discount" placeholder="例:10" style="width:100px" size="mini"></el-input> %折扣
            &nbsp;&nbsp;<i v-if="key != 0" class="iconfont icon-trash-alt" @click="delRules(key)"></i>
            <el-alert title="如满100元，给与80%折扣，即100x80%，折后价为20元。" type="error"> </el-alert>
          </div>
          <div v-if="form.condition_type == 'quantity'" v-for="(item,key) in conditionValue" :key="key" class="content-padded">
            消费满 <el-input type="input" v-model="item.full" placeholder="整数数字" style="width:100px" size="mini"></el-input> 件，给予 <el-input type="input" v-model="item.discount" placeholder="例:10" style="width:100px" size="mini"></el-input> %折扣
            &nbsp;&nbsp;<i v-if="key != 0" class="iconfont icon-trash-alt" @click="delRules(key)"></i>
            <el-alert title="如满100元，给与80%折扣，即100x80%，折后价为20元。" type="error"> </el-alert>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="规则描述">
        <el-col :span="20">
          <el-input type="textarea" :rows="3" v-model="form.marketing_desc" placeholder="规则描述"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="可参与次数">
        <el-input type="input" v-model="form.join_limit" placeholder="整数数字"></el-input>
      </el-form-item>
      <el-form-item label="适用会员">
        <el-checkbox-group v-model="validGrade">
          <el-checkbox v-for="grade in memberGrade" :label="grade.grade_id" :key="grade.grade_id">{{grade.grade_name}}</el-checkbox>
          <el-checkbox v-for="vipdata in vipGrade" :label="vipdata.lv_type" :key="vipdata.lv_type">付费{{vipdata.grade_name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="适用平台">
        <el-radio-group v-model="form.used_platform">
          <el-radio :label="0">全场可用</el-radio>
          <!-- <el-radio :label="1">只用于pc端</el-radio>
          <el-radio :label="2">只用于小程序端</el-radio>
          <el-radio :label="3">只用于h5端</el-radio> -->
        </el-radio-group>
      </el-form-item>
      <el-form-item label="有效期">
        <el-col :span="20">
          <el-date-picker
            v-model="activity_date"
            type="datetimerange"
            range-separator="至"
            start-placeholder="生效时间"
            end-placeholder="过期时间"
            format="yyyy/MM/dd HH:mm:ss"
            value-format="timestamp"
            :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-col>
      </el-form-item>
      <StoreSelect :store-visible="storeVisible" :is-valid="true" :rel-shop-ids="relStores" :get-status="setStatus" @chooseStore="chooseStoreAction" @closeStoreDialog="closeStoreDialogAction"></StoreSelect>
    </el-card>
    <el-card header="绑定商品" shadow="naver">
      <SkuSelector @change="getItems" :data="relItems"></SkuSelector>
    </el-card>
    <!-- <el-card header="绑定店铺" shadow="naver" v-if="system_mode !== 'platform' && !is_distributor"> -->
    <el-card header="绑定店铺" shadow="naver">
      <el-button type="primary" @click="relStoresClick">选择店铺</el-button>
      <el-table v-if="relStores.length > 0" :data="relStores" style="line-height: normal">
        <el-table-column label="ID" prop="distributor_id" width="60"></el-table-column>
        <el-table-column label="名称" prop="name"></el-table-column>
        <el-table-column prop="address" label="地址" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="50">
          <template slot-scope="scope">
            <i class="iconfont icon-trash-alt" @click="deleteStoreRow(scope.$index, form.items)"></i>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <div class="content-center">
      <el-button type="primary" v-if="hasSaveButton" @click="submitActivityAction()">保存</el-button>
      <el-button @click.native="handleCancel">返回</el-button>
    </div>
  </el-form>
</template>

<script>
import { addMarketingActivity, updateMarketingActivity, getMarketingActivityInfo } from '../../../../api/promotions'
import { getGradeList } from '../../../../api/membercard'
import { listVipGrade } from '../../../../api/cardticket'
import { getDefaultCurrency } from '../../../../api/company'
import StoreSelect from '@/components/storeListSelect'
import SkuSelector from '@/components/function/skuSelector'
import store from '@/store'
export default {
  inject: ['refresh'],
  components:{
    StoreSelect,
    SkuSelector
  },
  data () {
    return {
      is_distributor: false,
      cursymbol: '￥',
      storeVisible: false,
      relItems: [],
      relStores: [],
      setStatus: false,
      form: {
        marketing_id: '',
        marketing_type: 'full_discount',
        marketing_name: '',
        marketing_desc: '',
        start_time: '',
        end_time: '',
        used_platform: 0,
        use_bound: 1,
        use_shop: 0,
        shop_ids: [],
        item_ids: [],
        test: [],
        item_type: 'normal',
        valid_grade: [],
        condition_type: 'totalfee',
        condition_value: [],
        join_limit: 0,
        promotion_tag: '满折',
      },
      vipGrade: [],
      memberGrade: [],
      conditionValue: [
        {full:'', discount:''},
      ],
      validGrade: [],
      activity_date: '',
      selectItemType: 'normal',
      itemVisible: false,
      setItemStatus: false,
      imgDialog: false,
      isGetImage: false,
      isIndeterminate: true,
      checkAll: false,
      hasSaveButton: true,
    }
  },
  watch: {
    'form.item_ids': {
      handler: function(val) {
        if (val) {
          this.form.use_bound = val.length > 0 ? 1 : 0
        }
      }
    },
    relStores(val) {
      if (val) {
        this.form.use_shop = val.length > 0 ? 1 : 0
      }
    }
  },
  methods:{
    getItems(data) {
      let ids = []
      data.forEach(item => {
        ids.push(item.itemId)
      })
      this.form.item_ids = ids
    },
    addRules () {
      this.conditionValue.push({full:'', discount:''})
    },
    delRules(index){
      this.conditionValue.splice(index,1)
    },
    relStoresClick(){
      this.storeVisible = true
      this.setStatus = true
    },
    chooseStoreAction (data) {
      this.storeVisible = false
      this.form.shop_ids = []
      if (data === null || data.length <= 0) return
      this.relStores = data
    },
    closeStoreDialogAction () {
      this.storeVisible = false
    },
    deleteStoreRow (index, ) {
      this.setStatus = false
      this.relStores.splice(index,1)
    },
    submitActivityAction () {
      const that = this
      if (this.activity_date.length > 0) {
        this.form.start_time = this.activity_date[0]/1000
        this.form.end_time = this.activity_date[1]/1000
      }

      if (this.conditionValue.length > 0) {
        this.form.condition_value = JSON.stringify(this.conditionValue)
      }
      if (this.validGrade.length > 0) {
        this.form.valid_grade = this.validGrade
      }

      this.form.shop_ids = []
      if (this.relStores && this.relStores.length > 0) {
          this.relStores.forEach( item => {
            this.form.shop_ids.push(item.distributor_id)
          })
      }

      if (this.form.item_ids && this.form.item_ids.length <= 0) {
        this.$message.error('参加活动的商品必填!')
        return false
      }
      this.use_bound = 1

      if (this.form.marketing_id) {
        updateMarketingActivity(this.form).then(res => {
          if(res.data.data.marketing_id){
            this.loading = false
            this.$message({
              message: '更新成功',
              type: 'success',
              duration: 2 * 1000,
              onClose () {
                that.refresh()
                that.$router.go(-1)
              }
            })
          } else {
            this.$message.error('保存失败!')
            return false
          }
        })
      } else {
        addMarketingActivity(this.form).then(res => {
          if(res.data.data.marketing_id){
            this.loading = false
            this.$message({
              message: '添加成功',
              type: 'success',
              duration: 2 * 1000,
              onClose () {
                that.refresh()
                that.$router.go(-1)
              }
            })
          } else {
            this.$message.error('保存失败!')
            return false
          }
        })
      }
    },
    getActivityDetail(id) {
      getMarketingActivityInfo({marketing_id:id}).then(res => {
        let response = res.data.data
        let data = {
          marketing_type: 'full_discount',
          promotion_tag: '满折',
          marketing_id: response.marketing_id,
          marketing_name: response.marketing_name,
          marketing_desc: response.marketing_desc,
          start_time: response.start_time,
          end_time: response.end_time,
          used_platform: response.used_platform,
          use_bound: response.use_bound,
          use_shop: response.use_shop,
          valid_grade: response.valid_grade,
          condition_type: response.condition_type,
          condition_value: response.condition_value,
          join_limit: response.join_limit,
          free_postage: response.free_postage,
          item_type: response.item_type
        }
        Object.assign(this.form, data)
        this.conditionValue = response.condition_value
        this.validGrade = response.valid_grade
        this.activity_date = [response.start_time*1000, response.end_time*1000]
        this.relItems = response.itemTreeLists || []
        this.relStores = response.storeLists || []
      })
    },
    handleCancel: function () {
      this.$router.back(-1)
    }
  },
  mounted () {
    if (store.getters.login_type === 'distributor') {
      this.is_distributor = true
    }
    if (this.$route.params.marketing_id) {
      this.getActivityDetail(this.$route.params.marketing_id)
    }

    if (this.$route.query.isnodata) {
      this.hasSaveButton = false
    }

    listVipGrade().then(response => {
      if(response != undefined && response.data.data && response.data.data.length >0) {
        this.vipGrade = response.data.data
      }
    })

    getGradeList().then(response => {
      if(response != undefined && response.data.data && response.data.data.length >0) {
        var result = response.data.data
        if(result) {
          this.memberGrade = result
        }
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// add.vue?83e2ea24